import { gql } from '@apollo/client';

export const GENERATE_DRIVER_DOWNLOAD_REPORT = gql`
    mutation GenerateDriverDownloadReport($filters: AccountDeliveryDriverFiltersTypeInput, $language: String!) {
        generateDriverDownloadReport(filters: $filters, language: $language)
    }
`;

export interface GenerateDriverDownloadReportResponse {
    generateDriverDownloadReport: string;
}

export interface GenerateDriverDownloadReportVariables {
    filters?: any;
    language: string;
}
